<template>
  <div class="content">
    <div class="title">{{ $t('common.step.2') }}</div>
    <div class="box_inner" ref="boxInnerRef" v-loading="isLoading || autoAddLoading">
      <div class="btns">
        <el-button size="small" type="primary" plain :icon="Plus" @click="handleClickAdd">
          {{ $t('common.email.addCustomer') }}
        </el-button>
        <el-upload
            ref="uploadRef"
            action=""
            style="display: inline-block;vertical-align:middle;margin: 0px 10px;"
            :accept="['.xls','.xlsx']"
            :auto-upload="false"
            :show-file-list="false"
            :on-change="handleUploadChange"
        >
          <el-button size="small" type="primary" plain :icon="Upload"
                     @click="uploadExcel">
            {{ $t("list.customer.location.import") }}
          </el-button>
        </el-upload>
        <el-button size="small" type="primary" plain :icon="Download"
                   @click="downloadFileAll">{{
            $t('write.send.all.email.down.template')
          }}
        </el-button>
        <el-button size="small" type="primary" plain :icon="EditPen" @click="handleClickManual">
          {{ $t('common.step.text.2') }}
        </el-button>
        <el-button size="small" type="primary" plain :icon="DocumentDelete" @click="handleClickDelete">
          {{ $t('send.all.clean.all') }}
        </el-button>
      </div>
      <div class="inner_box">
        <!-- 公海客户表 -->
        <el-table
            :data="customerList"
            ref="targetTable"
            style="width: 100%;margin-top: 16px;height: 480px;"
            @selection-change="handleSelectionChange"
            :cell-style="rowClassNamePublic"
            :header-cell-style="headerClassNamePublic"
            :row-key="row => row.id"
        >
          <el-table-column
              v-for="(item, index) in table_columns_public_list_marketing"
              :key="item.key"
              :label="item.key"
              :prop="item.value"
              label="Date"
              :width="handleClickSelectWidth(item,1)"
              :min-width="handleClickSelectMinWidth(item,1)"
          >
            <!--            :show-overflow-tooltip="item.value==='customerType'||item.value==='customerName'||item.value==='customerCode'||item.value==='customerOrigin'?true:false"-->
            <template #default="{ row, column, $index }">
              <template v-if="item.value === 'email'">
                <div :ref="ref => (refMap[`${row.id}_public_email`] = ref)"
                     @mouseover.stop="handleRef(refMap[`${row.id}_public_email`], row, 30)"
                     v-if="getTextWidth(row.email)>=middleValueWidth"
                     class="over_normal"
                     :key="row?.email"
                >
                  {{ row?.email }}
                </div>
                <div v-else class="over_normal">
                  {{ row?.email }}
                </div>
              </template>
              <template v-else-if="item.value === 'contactName'">
                <div class="hover" v-if="row.contactName?.length > 20">
                  <!-- 触发内容1 -->
                  <div class="over_normal" :ref="ref => (refMap[row.contactName] = ref)"
                       @mouseover.stop="handleRef(refMap[row.contactName], row, 2)">
                    {{ row.contactName }}
                  </div>
                </div>
                <template v-else>
                  <div class="over_normal">
                    {{ row.contactName }}
                  </div>
                </template>
              </template>
              <template v-else-if="item.value==='customerCode'">
                <div :ref="ref => (refMap[`${row.id}_public_code`] = ref)"
                     @mouseover.stop="handleRef(refMap[`${row.id}_public_code`], row, 7)"
                     v-if=" getTextLength(row.customerCode) > sizeMaxNumber"
                     class="over_normal"
                     :key="row.customerCode">
                  {{
                    getTextLength(row.customerCode) > sizeMaxNumber ? formatText(row.customerCode, sizeMaxNumber) : row.customerCode
                  }}
                </div>
                <div v-else class="over_normal">
                  {{ row.customerCode }}
                </div>
              </template>
              <template v-else-if="item.value ==='zoneAddress'">
                <div style="cursor: pointer;">
                  <!-- 触发内容1 -->
                  <el-image :ref="ref => (refMap[`${row.id}_public_img`] = ref)"
                            @mouseover.stop="handleRef(refMap[`${row.id}_public_img`], row, 3)"
                            v-if="row.zoneAddress"
                            :src="flag[row.zoneCode]"
                            style="width:26px;height:20px;margin-right:2px;vertical-align: middle;" :key="row.zoneCode"
                            lazy
                  />
                </div>
              </template>
              <template v-else-if="item.value === 'maiContactVOList'">
                <div class="hover" v-if="row.maiContactVOList?.length > 0">
                  <!-- 触发内容1 -->
                  <el-button link type="primary" :ref="ref => (refMap[row.id] = ref)"
                             @mouseover.stop="handleRef(refMap[row.id], row, 1)">
                    {{ row.maiContactVOList?.length }}
                  </el-button>
                </div>
                <div v-else>
                  <el-button link type="info">
                    {{ row.maiContactVOList?.length }}
                  </el-button>
                </div>
              </template>
              <template v-else-if="item.value ==='lastTime'">
                <div>{{ row.lastTime }}</div>
              </template>
              <template v-else-if="item.value === 'customerName'">
                <div :ref="ref => (refMap[`${row.id}_public_name`] = ref)"
                     @mouseover.stop="handleRef(refMap[`${row.id}_public_name`], row, 5)"
                     v-if="getTextWidth(row.customerName)>=middleValueWidth"
                     class="over_normal"
                     :key="row.customerName"
                >
                  {{ row.customerName }}
                </div>
                <div v-else class="over_normal">
                  {{ row.customerName }}
                </div>
              </template>
              <!--              <template v-else-if="item.value==='customerOrigin'">-->
              <!--                <div :ref="ref => (refMap[`${row.id}_source`] = ref)"-->
              <!--                     @mouseover.stop="handleRef(refMap[`${row.id}_source`], row, 6)"-->
              <!--                     v-if="getTextLength(row?.mailLabelVoList?.filter(it => it.type === 1)[0]?.name) > sizeMaxNumber"-->
              <!--                     class="over_normal"-->
              <!--                     :key="row?.mailLabelVoList?.filter(it => it.type === 1)[0]?.name">-->
              <!--                  <el-tag type="info" v-if="row?.mailLabelVoList?.filter(it => it.type === 1).length!==0">-->
              <!--                    {{-->
              <!--                      getTextLength(row?.mailLabelVoList?.filter(it => it.type === 1)[0]?.name) > sizeMaxNumber-->
              <!--                          ? formatText(row?.mailLabelVoList?.filter(it => it.type === 1)[0]?.name, sizeMaxNumber, true)-->
              <!--                          : row?.mailLabelVoList?.filter(it => it.type === 1)[0]?.name-->
              <!--                    }}-->
              <!--                  </el-tag>-->
              <!--                  <template v-if="row?.mailLabelVoList?.filter(it => it.type === 1).length>1">-->
              <!--                    +{{ row?.mailLabelVoList?.filter(it => it.type === 1).length - 1 }}-->
              <!--                  </template>-->
              <!--                </div>-->
              <!--                <div v-else class="over_normal">-->
              <!--                  <el-tag type="info"-->
              <!--                          v-if="row?.mailLabelVoList && row?.mailLabelVoList?.filter(it => it.type === 1).length!==0">-->
              <!--                    {{ row?.mailLabelVoList?.filter(it => it.type === 1)[0]?.name }}-->
              <!--                  </el-tag>-->
              <!--                  <template v-else></template>-->
              <!--                  <template v-if="row?.mailLabelVoList?.filter(it => it.type === 1).length>1">-->
              <!--                    +{{ row?.mailLabelVoList?.filter(it => it.type === 1).length - 1 }}-->
              <!--                  </template>-->
              <!--                </div>-->
              <!--              </template>-->
              <!--              <template v-else-if="item.value==='customerIntention'">-->
              <!--                &lt;!&ndash;          {{ getTextLength(row?.mailLabelVoList.filter(item => item.type === 1)[0]?.name) }}&ndash;&gt;-->
              <!--                <div :ref="ref => (refMap[`${row.id}_source`] = ref)"-->
              <!--                     @mouseover.stop="handleRef(refMap[`${row.id}_product`], row, 11)"-->
              <!--                     v-if="getTextLength(row?.mailLabelVoList?.filter(it => it.type === 2)[0]?.name) > sizeMaxNumber"-->
              <!--                     class="over_normal"-->
              <!--                     :key="row?.mailLabelVoList?.filter(it => it.type === 2)[0]?.name">-->
              <!--                  <el-tag type="info" v-if="row?.mailLabelVoList?.filter(it => it.type === 2).length!==0">-->
              <!--                    {{-->
              <!--                      getTextLength(row?.mailLabelVoList?.filter(it => it.type === 2)[0]?.name) > sizeMaxNumber-->
              <!--                          ? formatText(row?.mailLabelVoList?.filter(it => it.type === 2)[0]?.name, sizeMaxNumber, true)-->
              <!--                          : row?.mailLabelVoList?.filter(it => it.type === 2)[0]?.name-->
              <!--                    }}-->
              <!--                  </el-tag>-->
              <!--                  <template v-if="row?.mailLabelVoList?.filter(it => it.type === 2).length>1">-->
              <!--                    +{{ row?.mailLabelVoList?.filter(it => it.type === 2).length - 1 }}-->
              <!--                  </template>-->
              <!--                </div>-->
              <!--                <div v-else class="over_normal">-->
              <!--                  <el-tag type="info"-->
              <!--                          v-if="row?.mailLabelVoList&&row?.mailLabelVoList?.filter(it => it.type === 2).length!==0">-->
              <!--                    {{ row?.mailLabelVoList?.filter(it => it.type === 2)[0]?.name }}-->
              <!--                  </el-tag>-->
              <!--                  <template v-else></template>-->
              <!--                  <template v-if="row?.mailLabelVoList?.filter(it => it.type === 2).length>1">-->
              <!--                    +{{ row?.mailLabelVoList?.filter(it => it.type === 2).length - 1 }}-->
              <!--                  </template>-->
              <!--                </div>-->
              <!--              </template>-->
              <!--              <template v-else-if="item.value === 'customerType'">-->
              <!--                <div :ref="ref => (refMap[`${row.id}_type`] = ref)"-->
              <!--                     @mouseover.stop="handleRef(refMap[`${row.id}_type`], row, 4)"-->
              <!--                     v-if="getTextLength(row.customerType) > sizeMaxNumber"-->
              <!--                     :key="row.customerType"-->
              <!--                     class="over_normal">-->
              <!--                  {{-->
              <!--                    getTextLength(row.customerType) > sizeMaxNumber ? formatText(row.customerType, sizeMaxNumber) : row.customerType-->
              <!--                  }}-->
              <!--                </div>-->
              <!--                <div v-else class="over_normal">-->
              <!--                  {{ row.customerType }}-->
              <!--                </div>-->
              <!--              </template>-->
              <!--              <template v-else-if="item.value==='createName'">-->
              <!--                <div :ref="ref => (refMap[`${row.id}_create_name`] = ref)"-->
              <!--                     @mouseover.stop="handleRef(refMap[`${row.id}_create_name`], row, 8)"-->
              <!--                     v-if="getTextLength(row.createName) > sizeMaxNumber"-->
              <!--                     class="over_normal"-->
              <!--                     :key="row.createName">-->
              <!--                  {{-->
              <!--                    getTextLength(row.createName) > sizeMaxNumber ? formatText(row.createName, sizeMaxNumber) : row.createName-->
              <!--                  }}-->
              <!--                </div>-->
              <!--                <div v-else class="over_normal">-->
              <!--                  {{ row.createName }}-->
              <!--                </div>-->
              <!--              </template>-->
            </template>
          </el-table-column>
          <el-table-column :label="$t('common.cz')" :width="100">
            <template #default="{ row, column, $index }">
              <!--删除-->
              <ConfirmDeletePopover
                  :visible="row.popoverVisibleDelete"
                  :width="164"
                  :message="$t('sys.message.ask.delete')"
                  :ref="`popover-${$index}`"
                  @update:visible="(value) => (row.popoverVisibleDelete = value)"
                  @confirm:delete="handleDeleteRowCustomer(row, column, $index)"
              >
                <template #settings>
                  <el-icon style="color: #c8453f;font-size: 20px;" @click.native.stop="row.popoverVisibleDelete = true">
                    <CircleCloseFilled/>
                  </el-icon>
                </template>
              </ConfirmDeletePopover>
            </template>
          </el-table-column>
          <template #empty>
            <el-empty :description="$t('common.data.empty')" :image="emptyUrl"/>
          </template>
        </el-table>
        <!-- 分页 -->
        <div class="pages">
          <Pagination v-model:modelValue="currentPublic"
                      v-model:pageSizeValue="sizePublic"
                      :total="totalsPublic"
                      v-if="totalsPublic"
                      ref="PageZQ"
                      :maxNumber="maxNumber"
                      :selected="selectedCount"
                      @change="handleCurrentChange"
                      :is-show-select="false"
                      :isShowSelectItem="false"
          ></Pagination>
        </div>
      </div>
    </div>
  </div>
  <!--  el-popover-->
  <el-popover
      ref="popoverRef"
      v-model:visible="visiblePopover"
      :virtual-ref="tempRef"
      virtual-triggering
      :popper-style="{ minWidth: '60px', width: 'auto' }"
      trigger="hover"
      effect="dark"
  >
    <template v-if="popoverType === 1">
      <!-- 业务逻辑1 -->
      <div class="popover-content" v-html="
      '<div>' +
      activeItemElpopover.maiContactVOList
        .map(item => `${item.contactName}<br/>`)
        .join('') +
      '</div>'
    "></div>
    </template>
    <template v-else-if="popoverType === 2">
      <!-- 业务逻辑2 -->
      <!--      <div class="popover-content" v-html="-->
      <!--      '<div>' +-->
      <!--      activeItemElpopover.mangerVOList-->
      <!--        .map(item => `${item.managerName}<br/>`)-->
      <!--        .join('') +-->
      <!--      '</div>'-->
      <!--    "></div>-->
      <div class="popover-content">
        {{ activeItemElpopover.contactName }}
      </div>
    </template>
    <template v-else-if="popoverType === 3">
      <div class="popover-content">{{ activeItemElpopover.zoneAddress }}</div>
    </template>
    <template v-else-if="popoverType === 4">
      <div class="popover-content">{{ activeItemElpopover.customerType }}</div>
    </template>
    <template v-else-if="popoverType === 5">
      <div class="popover-content">{{ activeItemElpopover.customerName }}</div>
    </template>
    <template v-else-if="popoverType === 6">
      <div class="popover-content">
        {{ activeItemElpopover?.mailCustomerOriginDetailVoList?.filter(it => it.type === 1)[0].name }}
      </div>
    </template>
    <template v-else-if="popoverType === 7">
      <div class="popover-content">{{ activeItemElpopover.customerCode }}</div>
    </template>
    <template v-else-if="popoverType === 8">
      <div class="popover-content">{{ activeItemElpopover.createName }}</div>
    </template>
    <template v-else-if="popoverType === 9">
      <div class="popover-content">{{ activeItemElpopover.auditName }}</div>
    </template>
    <template v-else-if="popoverType === 10">
      <div class="popover-content">{{ activeItemElpopover.userName }}</div>
    </template>
    <template v-else-if="popoverType === 11">
      <div class="popover-content">
        {{ activeItemElpopover?.mailProductDetailVoList?.filter(it => it.type === 2)[0].name }}
      </div>
    </template>
    <template v-else-if="popoverType===30">
      <div class="popover-content">
        {{ activeItemElpopover?.email }}
      </div>
    </template>
  </el-popover>

  <!--  添加客户 -->
  <addNewCustomer :isChecked="form.to" v-if="visitable" v-model="visitable" @close="close"
                  @addToEmail="getAddTo"></addNewCustomer>
  <!--  清空列表-->
  <clean-customer-dialog v-if="visitableDelete" v-model="visitableDelete" @close="closeDelete"
                         :isHeadLine="false" @getList="loadUsers"></clean-customer-dialog>
  <!--  手动录入-->
  <manual-input-dialog v-if="visitableManual" v-model="visitableManual"
                       @close="visitableManualClose" :isHeadLine="false" @addToEmail="getAddTo"></manual-input-dialog>

  <UploadExcel v-if="uploadExcelVisitable" v-model="uploadExcelVisitable" @close="closeUploadExcel"
               @addTo="getAddTo" :showTargetEmails="showTargetEmails"></UploadExcel>
</template>

<script setup>
import {computed, nextTick, onBeforeUnmount, onMounted, ref, watch} from "vue";
import {i18n} from "@/lang";
import {useStore} from "vuex";
import {onBeforeRouteLeave, useRoute, useRouter} from "vue-router";
import {DocumentDelete, Download, EditPen, Plus, Upload} from "@element-plus/icons-vue";
import {table_columns_public_list_marketing} from "@/views/Customer/map";
import {formatText, getTextLength, getTextWidth} from "@/utils/util";
import flag from "@/assets/flag";
import {emptyUrl, POPOVER_DELAY_TIME} from "@/utils/statusParams";
import {ElMessage, ElTable} from "element-plus";
import ConfirmDeletePopover from "@/components/ConfirmDeletePopover.vue";
import {flexWidth} from "@/utils/tableWidth";
import {debouncePlus} from "@/utils/mylodash";
import Pagination from "@/components/Pagination/index.vue";
import addNewCustomer from "./com/addNewCustomer.vue"
import {UserTable} from './db_user'
import {CustomerTable} from './db_customer'
import CleanCustomerDialog from "@/views/Marketing/com/cleanCustomerDialog.vue";
import ManualInputDialog from "@/views/Marketing/com/manualInputDialog.vue";
import UploadExcel from "@/components/DiaPops/UploadExcel.vue";
import * as XLSX from 'xlsx/xlsx.mjs';
import {getGroupMassCustomerList, getRuleFilter} from "@/api/customer";
import sessionStore from "@/utils/sessionStore";


const store = useStore();
const router = useRouter();
const route = useRoute()

const teamId = computed(() => store.state.email.teamID);

const props = defineProps({
  currentMassEmailObj: {
    type: Object,
    default: () => ({})
  }
})

const options = [
  {
    value: 1,
    label: i18n.global.t('common.step.txt.select.1'),
  },
  {
    value: 2,
    label: i18n.global.t('common.step.txt.select.2'),
  },
  {
    value: 3,
    label: i18n.global.t('common.step.txt.select.3'),
  },
  {
    value: 4,
    label: i18n.global.t('common.step.txt.select.4'),
  },
  {
    value: 5,
    label: i18n.global.t('common.step.txt.select.5'),
  },
  {
    value: 6,
    label: i18n.global.t('common.step.txt.select.6'),
  },
  {
    value: 7,
    label: i18n.global.t('common.step.txt.select.7'),
  },
  {
    value: 8,
    label: i18n.global.t('common.step.txt.select.8'),
  },
]

const value = ref([])

// 添加客户
const form = ref({
  to: []
})

const downloadFileAll = () => {
  // alert('download files')
  const filename = '群发列表.xlsx'
  let a = document.createElement('a');
  a.href = '/static/' + filename;
  //路径中'/'为根目录，即index.html所在的目录
  a.download = name;
  a.click();
};


// 导入
// 上传excel
const uploadExcelVisitable = ref(false)
const uploadExcel = () => {
  // uploadExcelVisitable.value = true;
}
const closeUploadExcel = () => {
  uploadExcelVisitable.value = false;
}

// 从 excel 中解析出来的 email
const showTargetEmails = ref([])

async function handleUploadChange(file) {
  let dataBinary = await readFile(file.raw);
  let workBook = XLSX.read(dataBinary, {type: "binary", cellDates: true});
  let workSheet = workBook.Sheets[workBook.SheetNames[0]];
  const data = XLSX.utils.sheet_to_json(workSheet);

  console.log('data', data)
  // 这里可能需要做国际化处理
  const allEmails = extractEmailsGroup(data)
  console.log(allEmails, 'allEmails')
  // 这里可能需要做验证--校验
  showTargetEmails.value = [...showTargetEmails.value, ...allEmails.filter(item => item.email !== undefined)];
  console.log(showTargetEmails.value, 'showTargetEmails.value'); //最终获取JSON数据
  // ...操作数据
  // uploadExcelVisitable.value = true;

  if (showTargetEmails.value.length !== 0) {
    // 整合数据
    const result = showTargetEmails.value.map(item => ({
      email: item.email || "",
      customerCode: item.customerCode || "",
      zoneAddress: item.zoneAddress || "",
      zoneCode: item.zoneCode || "",
      contactName: item.name.replace(/[()]/g, '') || "",
      type: 3
    }))
    getAddTo(result)
  } else {
    ElMessage.warning(i18n.global.t('import.excel.info'))
  }
}

function extractEmailsGroup(data) {
  return data.map(function (entry) {
    return {
      name: `(${entry[`联系人姓名（没有姓名则留白即可）`]})`, email: entry[`联系人邮箱（一行填一个邮箱）`]
    };
  });
}

const readFile = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsBinaryString(file);
    reader.onload = (e) => {
      resolve(e.target.result);
    };
    reader.onerror = (e) => {
      reject(e);
    };
  });
}


// 手动录入
const visitableManual = ref(false)
const visitableManualClose = () => {
  visitableManual.value = false
}
const handleClickManual = () => {
  visitableManual.value = true;
}


const visitable = ref(false);
const close = () => {
  visitable.value = false
}


watch(() => props.currentMassEmailObj, (newValue) => {
  if (newValue) {
    console.log(newValue, 'newValueddd')
  }
})

const getAddTo = async (targetEmailCustomerList) => {
  // 缓存数据
  console.log(targetEmailCustomerList, 'targetEmailCustomerList')
  // 数据整合 字段只要 邮箱地址 联系人 客户编号 公司名称 所属地区
  const targetList = targetEmailCustomerList.map(item => {
    const obj = {
      email: item.email || "",
      customerName: item.customerName || "",
      customerCode: item.customerCode || "",
      zoneAddress: item.zoneAddress || "",
      zoneCode: item.zoneCode || "",
      isCheck: 1,
      type: item.type || 2,
      contactId: item.contactId ?? null,
      contactName: item.contactName || ""
    }
    if (item.id) {
      obj.id = item.id
    }
    // 如果存在 customerId，则添加
    if (item.customerId) {
      obj.customerId = item.customerId;
    }
    if (item.contactId) {
      obj.contactId = item.contactId;
    }

    return obj
  })

  const existingList = await UserTable.getAll()
  const existingEmailSet = new Set(
      existingList
          .map(it => (it?.email || '').trim().toLowerCase())
          .filter(Boolean)
  )

  const uniqueIncoming = Array.from(
      new Map(
          targetList
              .map(it => ({
                ...it,
                email: (it?.email || '').trim(),
              }))
              .filter(it => it.email)
              .reverse()
              .map(it => {
                const key = it.email.toLowerCase() || it.customerCode
                return [key, it]
              })
      ).values()
  ).reverse()

  const toAdd = uniqueIncoming.filter(it => !existingEmailSet.has(it.email.toLowerCase()))

  if (toAdd.length) {
    await UserTable.bulkAdd(toAdd)
  }
  await loadUsers()
}

const autoAddFromCustomerIdList = async () => {
  autoAddLoading.value = true
  try {
    const list = await CustomerTable.getAll()
    const customerIdList = Array.from(new Set((list || []).map(it => it?.customerId).filter(Boolean)))
    console.log(customerIdList, 'customerIdList');
    if (!customerIdList.length) {
      ElMessage.warning(i18n.global.t('common.data.empty'))
      return
    }

    const requestTeamId = teamId.value || sessionStore.get('teamId')
    const payload = {
      teamId: requestTeamId,
      pageSize: customerIdList.length,
      pageNo: 1,
      isSelectAll: 1,
      type: 1,
      massOrigin: 3,
      customerIdList,
      allEmail: true,
    }

    const res = await getGroupMassCustomerList(payload)
    const records = res?.result?.records ?? []
    if (!records.length) {
      ElMessage.warning(i18n.global.t('common.data.empty'))
      return
    }
    await getAddTo(records)
  } finally {
    autoAddLoading.value = false
  }
  //  ElMessage.success(i18n.global.t('sys.message.success'))
}

const handleClickAdd = () => {
  visitable.value = true;
}

// 清空部分
const visitableDelete = ref(false)
const handleClickDelete = () => {
  visitableDelete.value = true
}
const closeDelete = () => {
  visitableDelete.value = false
}

// 分页
const currentPublic = ref(1);
const sizePublic = ref(20);
const totalsPublic = ref(0);
const selectedCount = ref(10)

const handleCurrentChange = async (page) => {
  console.log(page, 'page')
  const {pageNo, pageSize} = page
  currentPublic.value = pageNo;
  sizePublic.value = pageSize;
  //  重新获取数据
  hidePopover()
  await loadUsers();
}

// 加载全部用户
const loadUsers = async () => {
  try {
    hidePopover()
    isLoading.value = true
    const result = await UserTable.getPageWithTotal(currentPublic.value, sizePublic.value)
    console.log(result, 'page')
    customerList.value = result.data;
    totalsPublic.value = result.total
    sizePublic.value = result.pageSize;
    isLoading.value = false
  } catch (e) {
    isLoading.value = false
  }
}

const openNewTab = (path, query = {}) => {
  const routeInfo = router.resolve({path, query});
  window.open(routeInfo.href, '_blank');
};

const userDataInformation = computed(() => store.state.cloud.userDataInformation)
const toBuy = () => {
  //   购买edm
  openNewTab('/personal/edmDetails')
}

const customerList = ref([])
const isLoading = ref(false)
const autoAddLoading = ref(false)

watch(customerList, () => {
  hidePopover()
})
const handleSelectionChange = () => {

}


const boxInnerRef = ref(null)
const popoverRef = ref(null)
const updatePopoverPosition = async () => {
  await nextTick()
  popoverRef.value?.updatePopper?.()
}

const hidePopover = () => {
  visiblePopover.value = false
  tempRef.value = null
  activeItemElpopover.value = null
}


// el-popover 优化
const refMap = ref({})
const tempRef = ref()
const visiblePopover = ref(false)
// -1-字句审核 0-整句审核 1-日志查看
const popoverType = ref(0)
const activeItemElpopover = ref(null)

const handleRef = debouncePlus((ref, item, type) => {
  console.log('refMap', refMap.value)
  tempRef.value = ref
  popoverType.value = type
  activeItemElpopover.value = item;
  if (type === 1) {
    // ...业务逻辑1
  } else {
    // ...业务逻辑2、3
  }
  visiblePopover.value = true
  updatePopoverPosition()
}, POPOVER_DELAY_TIME)

watch(visiblePopover, (val) => {
  if (val) {
    updatePopoverPosition()
  }
})

const handleDeleteRowCustomer = async (row) => {
  await UserTable.deleteById(row?.id)
  await loadUsers()
}


const headerClassNamePublic = ({row, column, rowIndex, columnIndex}) => {
  if (columnIndex === 0 || columnIndex === 1 || columnIndex === 3 || columnIndex === 5) {
    return {'text-align': 'left', background: '#f9f9f9', color: 'black', padding: '8px 0px'}
  } else {
    return {'text-align': 'center', background: '#f9f9f9', color: 'black', padding: '8px 0px'}
  }
}

const rowClassNamePublic = ({row, column, rowIndex, columnIndex}) => {
  if (columnIndex === 0 || columnIndex === 1 || columnIndex === 3 || columnIndex === 5) {
    return {textAlign: 'left'}
  } else {
    return {textAlign: 'center'}
  }
}

const lang = computed(() => store.state.system.langLocal)
const middleValueWidth = ref(160)
// 字数大致限制
const sizeMaxNumber = ref(13)
const handleClickSelectWidth = (item, type) => {
  if (item.value === "customerCode") {
    return flexWidth('customerCode', customerList.value, i18n.global.t('common_customer_number')) > middleValueWidth.value ? middleValueWidth.value : flexWidth('customerCode', customerList.value, i18n.global.t('common_customer_number')) + 20
  } else if (item.value === "customerType") {
    return flexWidth('customerType', customerList.value, i18n.global.t('common_customer_type')) > middleValueWidth.value ? middleValueWidth.value : flexWidth('customerType', customerList.value, i18n.global.t('common_customer_type')) + 20
  } else if (item.value === 'customerOrigin') {
    return flexWidth('customerOrigin', customerList.value, i18n.global.t('common.customer.source')) > middleValueWidth.value ? middleValueWidth.value : flexWidth('customerOrigin', customerList.value, i18n.global.t('common.customer.source')) + 60
  } else if (item.value === 'customerIntention') {
    return flexWidth('customerIntention', customerList.value, i18n.global.t('common.interest.product')) > middleValueWidth.value ? middleValueWidth.value : flexWidth('customerIntention', customerList.value, i18n.global.t('common.interest.product')) + 60
  } else if (item.value === 'createName') {
    return flexWidth('createName', customerList.value, i18n.global.t('common.byinput')) > middleValueWidth.value ? middleValueWidth.value : flexWidth('createName', customerList.value, i18n.global.t('common.byinput')) + 20
  } else if (item.value === 'auditName') {
    if (type === 1) {
      return 80
    } else if (type === 2) {
      return flexWidth('auditName', tableData.value, i18n.global.t('common.shr')) > middleValueWidth.value ? middleValueWidth.value : flexWidth('auditName', customerList.value, i18n.global.t('common.shr'))
    }
  } else if (item.value === 'userName') {
    if (type === 1) {
      return 80
    } else if (type === 2) {
      return flexWidth('userName', tableData.value, i18n.global.t('common.claim.user')) > middleValueWidth.value ? middleValueWidth.value : flexWidth('userName', customerList.value, i18n.global.t('common.claim.user'))
    }
  } else if (item.value === 'customerLevel') {
    return lang.value !== 'zh-CN' ? 140 : 80;
  } else if (item.value === 'maiContactVOList' || item.value === 'zoneAddress') {
    return 80;
  } else if (item.value === 'lastTime' || item.value === 'applyTime' || item.value === 'followTime') {
    return 150;
  } else if (item.value === 'setting' || item.value === 'auditStatus') {
    return 120;
  } else if (item.value === 'mangerVOList') {
    return 80;
  } else {
    return "auto"
  }
}
const handleClickSelectMinWidth = (item, type) => {
  if (item.value === "customerLevel") {
    return 140;
  } else if (item.value === 'createName') {
    return 200;
  } else if (item.value === 'email') {
    return 200;
  } else if (item.value === 'customerName') {
    return 200;
  } else if (item.value === 'contactName') {
    return 200;
  } else {
    return "auto";
  }
}


onMounted(async () => {
  sessionStore.set("CustomerAddNewIsReset", false)
  await store.dispatch("cloud/queryByUserIdApis")
  await loadUsers()

  const el = boxInnerRef.value
  if (el && el.addEventListener) {
    el.addEventListener('scroll', updatePopoverPosition, {passive: true})
  }
  window.addEventListener('resize', updatePopoverPosition, {passive: true})

  const targetMassOrigin = route.query.massOrigin * 1
  const targetOpen = route.query.isOpen * 1
  // if (((targetMassOrigin === 3 && targetOpen === 1) || (targetMassOrigin === 4 && targetOpen === 1)) && customerList.value.length === 0) {
  if (targetMassOrigin === 3 && targetOpen === 1 && customerList.value.length === 0) {
    try {
      await autoAddFromCustomerIdList()
    } catch (e) {
      console.log(e)
      ElMessage.error(i18n.global.t('sys.message.error'))
    }
    return
  }

  if (targetMassOrigin === 4 && targetOpen === 1 && customerList.value.length === 0) {
    visitable.value = true;
  }
})

onBeforeRouteLeave(() => {
  sessionStore.set("CustomerAddNewIsReset", false)
})

onBeforeUnmount(() => {
  const el = boxInnerRef.value
  if (el && el.removeEventListener) {
    el.removeEventListener('scroll', updatePopoverPosition)
  }
  window.removeEventListener('resize', updatePopoverPosition)
  sessionStore.set("CustomerAddNewIsReset", false)
})

const maxNumber = ref(7000)
defineExpose({
  maxNumber,
  totalsPublic,
  loadUsers,
  getAddTo,
})

</script>

<style lang="less" scoped>
.content {
  margin: 0px auto;
  height: 100%;
  width: 57vw;
  min-width: 57vw;
  text-align: left;

  .title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #000000;
  }

  .box_inner {
    padding: 20px;
    margin-top: 10px;
    max-height: calc(100vh - 260px);
    overflow: scroll;
    background: #FAFAFA;
  }
}

:deep(.el-empty__image img) {
  width: 54% !important;
}

:deep(.el-table) {
  font-size: 13px !important;
}
</style>